import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { homeForRole } from "@/lib/roles";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Articoli from "@/pages/Articoli";
import ArticoliHub from "@/pages/ArticoliHub";
import Anagrafiche from "@/pages/Anagrafiche";
import Ubicazioni from "@/pages/Ubicazioni";
import Utenti from "@/pages/Utenti";
import Permessi from "@/pages/Permessi";
import OrdiniProduzione from "@/pages/OrdiniProduzione";
import ProduzioneOperatore from "@/pages/ProduzioneOperatore";
import Pedane from "@/pages/Pedane";
import TrasferimentoMagazzino from "@/pages/TrasferimentoMagazzino";
import UscitaMerce from "@/pages/UscitaMerce";
import Documenti from "@/pages/Documenti";
import Impostazioni from "@/pages/Impostazioni";
import ChangePassword from "@/pages/ChangePassword";
import StampaOrdineA4 from "@/pages/StampaOrdineA4";
import EstrusioneArticoli from "@/pages/EstrusioneArticoli";
import EstrusioneOrdini from "@/pages/EstrusioneOrdini";
import EstrusioneProduzione from "@/pages/EstrusioneProduzione";
import MagazzinoBobine from "@/pages/MagazzinoBobine";
import StampaOrdineEstrusioneA4 from "@/pages/StampaOrdineEstrusioneA4";
import AppShell from "@/components/layout/AppShell";

function LoadingScreen() {
    return (
        <div className="h-screen w-screen flex items-center justify-center text-slate-400">
            <div className="animate-pulse font-mono text-xs tracking-wider">CARICAMENTO…</div>
        </div>
    );
}

function Protected() {
    const { user } = useAuth();
    if (user === null) return <LoadingScreen />;
    if (!user) return <Navigate to="/login" replace />;
    if (user.must_change_password) return <Navigate to="/change-password" replace />;
    return <AppShell><Outlet /></AppShell>;
}

function BareProtected() {
    const { user } = useAuth();
    if (user === null) return <LoadingScreen />;
    if (!user) return <Navigate to="/login" replace />;
    return <Outlet />;
}

function GuestOnly({ children }) {
    const { user } = useAuth();
    if (user === null) return null;
    if (user) return <Navigate to={user.must_change_password ? "/change-password" : homeForRole(user.role)} replace />;
    return children;
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <div className="grain min-h-screen">
                    <Routes>
                        <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
                        <Route element={<BareProtected />}>
                            <Route path="/change-password" element={<ChangePassword />} />
                            <Route path="/stampa-ordine/:id" element={<StampaOrdineA4 />} />
                            <Route path="/estrusione/stampa/:id" element={<StampaOrdineEstrusioneA4 />} />
                        </Route>
                        <Route element={<Protected />}>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/articoli" element={<ArticoliHub />} />
                            <Route path="/articoli-legacy" element={<Articoli />} />
                            <Route path="/anagrafiche" element={<Impostazioni />} />
                            <Route path="/ubicazioni" element={<Impostazioni />} />
                            <Route path="/utenti" element={<Utenti />} />
                            <Route path="/permessi" element={<Impostazioni />} />
                            <Route path="/ordini-produzione" element={<OrdiniProduzione />} />
                            <Route path="/produzione" element={<ProduzioneOperatore />} />
                            <Route path="/pedane" element={<Pedane />} />
                            <Route path="/trasferimento-magazzino" element={<TrasferimentoMagazzino />} />
                            <Route path="/uscita-merce" element={<UscitaMerce />} />
                            <Route path="/documenti" element={<Documenti />} />
                            <Route path="/impostazioni" element={<Impostazioni />} />
                            <Route path="/estrusione/articoli" element={<ArticoliHub />} />
                            <Route path="/estrusione/ordini" element={<EstrusioneOrdini />} />
                            <Route path="/estrusione/produzione" element={<EstrusioneProduzione />} />
                            <Route path="/estrusione/bobine" element={<MagazzinoBobine />} />
                        </Route>
                        <Route path="*" element={<RoleAwareFallback />} />
                    </Routes>
                    <Toaster theme="dark" richColors position="top-right" />
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
}

// Fallback route: reindirizza alla home appropriata al ruolo (o al login se ospite)
function RoleAwareFallback() {
    const { user } = useAuth();
    if (user === null) return null;
    if (!user) return <Navigate to="/login" replace />;
    return <Navigate to={homeForRole(user.role)} replace />;
}
